import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import BillingMethodTotalLabel from "../../../common/pricing/billingmethodtotallabel.component.jsx"
import NumericLabel from 'react-pretty-numbers'
import Icon from "../../../common/icon/icon.component.jsx";
import PricingTableModal from "../pricingtablemodal.component.jsx";
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            invoice: this.props.invoice || null,
            modal: '',
        }
        this.handleOpenPricingTableModal = this.handleOpenPricingTableModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    handleOpenPricingTableModal(e) {
        e.preventDefault()
        this.setState({
            modal: <PricingTableModal
                invoice={this.state.invoice}
                onClose={this.handleCloseModal}
            />
        })
    }
    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    render() {
        let numberLabel = {
            justification: 'L',
            locales: AppContext.getLocale().getLanguage(),
            currency: true,
            currencyIndicator: this.state.invoice.attributes.currency,
            percentage: false,
            precision: 0,
            commafy: false,
            shortFormat: true,
            title: true,
        }
        return <div className={"row " + this.state.className}>
            {this.state.modal}
            <div className="col-12">
                <p className={"mb-1"}>
                    {this.state.object.attributes.billingType !== BILLING_TYPE.RETURN ? <FormattedMessage
                        id="invoice.analytics.events.invoice_sent_text"
                        defaultMessage="Invoice {identifier} has been sent for a total value of {totalValue}"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            totalValue: <strong><NumericLabel params={numberLabel}>
                                {this.state.invoice.attributes.totalAmount}
                            </NumericLabel></strong>,
                        }}
                    /> : <FormattedMessage
                        id="invoice.analytics.events.return_sent_text"
                        defaultMessage="Return {identifier} has been sent for a total value of {totalValue}"
                        values={{
                            identifier: <strong>{this.state.object.attributes.identifier}</strong>,
                            totalValue: <strong><NumericLabel params={numberLabel}>
                                {this.state.object.attributes.totalAmount}
                            </NumericLabel></strong>,
                        }}
                    />}
                </p>
            </div>
            <div className={'col-12 col-md-6 col-lg-4'}>
                <p className={'mb-2'}>
                    <button className={'btn btn-sm btn-outline-primary'} onClick={this.handleOpenPricingTableModal}>
                        <Icon value={'dollar-sign'} className={'mr-1'} />
                        <FormattedMessage
                            id="invoice.analytics.events.invoice_table_btn"
                            defaultMessage="Show details"
                        />
                    </button>
                </p>
            </div>
        </div>
    }

}

export default InvoiceEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-sent.component.jsx